<template>
    <MenuBaseSubmenu :listenerId="listenerId">
        <a :href="getLink('adkeys')" :class="{active: currentReport === 'adkeys'}">
            <span>{{ $t('lang.menu.search.context.adkeys') }}</span>
        </a>
        <a :href="getLink('ads')" :class="{active: currentReport === 'ads'}">
            <span>{{ $t('lang.menu.search.context.ads') }}</span>
        </a>
        <a :href="getLink('adconcurents')" :class="{active: currentReport === 'adconcurents'}">
            <span>{{ $t('lang.menu.search.context.adconcurents') }}</span>
        </a>
    </MenuBaseSubmenu>
</template>

<script>
import {Listeners} from "../../../constants/listeners";
import MenuBaseSubmenu from "./BaseSubmenu.vue";
import Submenu from "../mixins/Submenu";

export default {
    name: "MenuSubmenuContext",
    mixins: [Submenu],
    props: {
        domain: {
            type: String,
            required: true,
        }
    },
    data() {
        return {
            listenerId: Listeners.TOP_MENU_CONTEXT_HOVER,
        };
    },
    components: {
        MenuBaseSubmenu,
    },
}
</script>
